import { POPUP_TYPE } from '@/models/Popup';
import { tableBetSliceActions } from '@/modules/betTable/slice';
import {
    getHostLiveDataByHostId,
    hostLiveSliceActions,
} from '@/modules/hostLive/slice';
import { LiveDataSliceActions } from '@/modules/main/slice/liveData';
import { Action, Dispatch } from '@reduxjs/toolkit';
import { batch } from 'react-redux';
import { getHostById } from '../../../modules/host/slice';
import { popupSliceActions } from '../../../modules/popup/slice';
import store from '../../../store/store';
import { CMDSpForceStand, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDSpForceStandHandler extends AbstractHandler {
    _command: CMDSpForceStand;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDSpForceStand;
    }
    handle(dispatch: Dispatch<Action>): void {
        const state = store.getState();
        const host = getHostById(state, this._command.HostID);
        const hostLiveData = getHostLiveDataByHostId(
            state,
            this._command.HostID
        );
        if (host) {
            batch(() => {
                dispatch(
                    hostLiveSliceActions.updateCountDown({
                        hostId: host.HostId,
                        countDown: host.GameDelay
                            ? host.GameDelay.kickNoBetPlayer
                            : 0,
                        canLeave: false,
                    })
                );
                if (hostLiveData.CurrentResult) {
                    dispatch(
                        popupSliceActions.open(
                            'blackjack.force_stand',
                            POPUP_TYPE.ALERT,
                            undefined,
                            undefined,
                            undefined,
                            host.HostId
                        )
                    );
                    dispatch(
                        tableBetSliceActions.clearBets({
                            hostId: host.HostId,
                            gameId: hostLiveData.CurrentResult.GameID,
                        })
                    );
                    dispatch(
                        LiveDataSliceActions.updateHostBetInfo({
                            hostId: host.HostId,
                            totalBetAmount: 0,
                            totalWithHoldAmount: 0,
                            pendingBetAmount: 0,
                            pendingWithHoldAmount: 0,
                        })
                    );
                }
            });
        }
    }
}
